import { Banner, getSvgByName, SpinnerCircular } from '@repo/ui';
import c from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useMainAccount from 'services/account/useMainAccount';
import useKitSystemInfo from 'services/system-info/useKitSystemInfo';
import { addClosedBanner, checkIfBannerIsClosed } from 'store/banners';
import styles from './VersionUpdateBanner.module.css';

const BANNER_ID = 'version-update-banner';

export default function VersionUpdateBanner() {
  const { hasOutdatedKitVersion, currentKit, isUpdating } = useKitSystemInfo();

  const { data } = useMainAccount();
  const isClosed = useSelector(
    checkIfBannerIsClosed({ bannerId: BANNER_ID, keyId: data?.id ?? '' }),
  );
  const dispatch = useDispatch();

  const navigate = useNavigate();

  if (isUpdating)
    return (
      <Banner
        title='Update in progress'
        content='We’re updating your kits to the latest version. We’ll email you when it’s done.'
        icon={() => (
          <SpinnerCircular
            size={28}
            color='var(--purple-300)'
            secondaryColor='transparent'
          />
        )}
        className={c(styles.updateBanner, styles.container)}
        iconContainerClassName={styles.updateBannerIcon}
        color='purple'
        size='sm'
        variant='full'
      />
    );

  if (!hasOutdatedKitVersion) return null;

  function handleCloseBanner() {
    if (data)
      dispatch(addClosedBanner({ bannerId: BANNER_ID, keyId: data.id }));
  }

  function handleUpdate() {
    navigate('/results/update', {
      state: { from: `/results/${currentKit?.id}` },
    });
  }

  return (
    <Banner
      title='Version update recommended'
      content='Gut health science is evolving quickly. Update past reports to the latest version to ensure past and present results reflect the latest understanding of gut health.'
      color='orange'
      icon={getSvgByName('alertCircle')}
      iconClassName={styles.icon}
      className={styles.container}
      size='sm'
      variant='full'
      isClosed={isClosed}
      onClose={handleCloseBanner}
      action={{ label: 'Update', onClick: handleUpdate }}
    />
  );
}
